module.exports = __webpack_public_path__ + "static/media/ham.eaf95382.svg";